import classNames from "classnames";
import React, { FC, memo } from "react";

import { Flex, Link, Text } from "@/eworkitComponents";

import "./_legal-information-tab.scss";

interface Props {
  active: boolean;
  category: string;
  onTabClick: () => void;
}

const baseClass = "legal-information-tab";

export const LegalInformationTab: FC<Props> = memo(({ active, category, onTabClick }) => {
  return (
    <Flex direction="column" className={classNames(baseClass, active && `${baseClass}__active`)} padding={["md"]}>
      <Link onClick={onTabClick} color={active ? "dark" : "link"}>
        <Text text={category} color="secondary" size="lg" />
      </Link>
    </Flex>
  );
});
